<mat-card-subtitle>{{'DEDUPLICATION.INFO_MSG' | translate}}</mat-card-subtitle>
<mat-list *cidContentLoader="contentLoading">
    <div *ngFor="let user of foundUsers">
        <mat-divider></mat-divider>
        <mat-list-item (click)="deduplicationLogin(user.sub)">
            <mat-icon matListIcon [inline]="true" color="primary">account_circle</mat-icon>
            <h3 matLine> {{user.displayName}} </h3>
            <p matLine>
                <span> {{user.email}} </span>
            </p>
        </mat-list-item>
    </div>
    <mat-divider></mat-divider>
    <mat-list-item (click)="registerDeduplication()">
        <mat-icon matListIcon>close</mat-icon>
        <h3 matLine> {{'DEDUPLICATION.DECLINE_MSG' | translate}}</h3>
        <p matLine>
            <span> {{currentEmail}} </span>
        </p>
    </mat-list-item>>
    <div class="mat-error">{{errorMessage | translate}} </div>
</mat-list>
